var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 22.6667,
    height: 22.6667,
    rx: 3.33333,
    stroke: "currentColor",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9645 7.74224C17.8818 7.65893 17.7835 7.5928 17.6752 7.54767C17.5669 7.50254 17.4507 7.47931 17.3333 7.47931C17.216 7.47931 17.0998 7.50254 16.9915 7.54767C16.8832 7.5928 16.7849 7.65893 16.7022 7.74224L10.08 14.3734L7.29779 11.5822C7.21199 11.4994 7.11071 11.4342 6.99973 11.3905C6.88874 11.3467 6.77023 11.3253 6.65096 11.3273C6.53169 11.3294 6.41399 11.3549 6.30459 11.4025C6.19519 11.45 6.09622 11.5187 6.01334 11.6045C5.93046 11.6903 5.8653 11.7915 5.82156 11.9025C5.77782 12.0135 5.75637 12.132 5.75844 12.2513C5.7605 12.3706 5.78604 12.4883 5.83359 12.5977C5.88114 12.7071 5.94977 12.806 6.03557 12.8889L9.4489 16.3022C9.53153 16.3856 9.62984 16.4517 9.73816 16.4968C9.84648 16.5419 9.96267 16.5652 10.08 16.5652C10.1974 16.5652 10.3135 16.5419 10.4219 16.4968C10.5302 16.4517 10.6285 16.3856 10.7111 16.3022L17.9645 9.04891C18.0547 8.96567 18.1267 8.86465 18.1759 8.7522C18.2252 8.63976 18.2506 8.51833 18.2506 8.39557C18.2506 8.27282 18.2252 8.15139 18.1759 8.03895C18.1267 7.9265 18.0547 7.82548 17.9645 7.74224V7.74224Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.7e66673c123900b86e36f72e70f4084d.svg";
export { ForwardRef as ReactComponent };